module.exports = new __parcel__URL__("AK_AddonIcon.7997ef8d.svg").toString();